import React from 'react';
import { motion } from 'framer-motion';

const GradientButton = ({ onClick, children, disabled = false, variant = 'primary', fullWidth = false, className = '' }) => {
  const variants = {
    primary: 'bg-gradient-to-r from-violet-600 to-pink-600 text-white hover:from-violet-700 hover:to-pink-700 hover:shadow-xl glow-hover-gradient',
    secondary: 'bg-gradient-to-r from-violet-500 to-purple-500 text-white hover:from-violet-600 hover:to-purple-600 hover:shadow-xl',
    outline: 'bg-white border-2 border-violet-600 text-violet-600 hover:bg-violet-50 hover:border-violet-700'
  };

  const disabledStyles = disabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed opacity-50' : variants[variant];

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      whileHover={!disabled ? { scale: 1.02 } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
      className={`${fullWidth ? 'w-full' : ''} px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg transition-all duration-300 shadow-lg focus:outline-none focus:ring-4 focus:ring-violet-300 ${disabledStyles} ${className}`}
    >
      {children}
    </motion.button>
  );
};

export default GradientButton;
